import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { UtilsClientService } from '../../utils.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { SecurityAlertModalComponent } from '../../../shared/components/security-alert-modal/security-alert-modal.component';
import { GetPanelResponse } from 'src/app/shared/services/responses/panel/get-panel.response';
import { KeepAliveService } from 'src/app/shared/services/API/panel/keep-alive.service';
import { HealthUnitTimeService } from 'src/app/shared/services/API/user/health-unit-time.service';
import { VerifyWaitingTimeService } from 'src/app/shared/services/API/queue/verify-waiting-time.service';
import { PanelLoginRequest } from 'src/app/shared/services/requests/panel/panel-login.request';
import { GetQueueRequest } from 'src/app/shared/services/requests/queue/get-queue.request';

@Component({
  selector: 'app-display',
  templateUrl: './display.component.html',
  styleUrls: ['./display.component.css']
})
export class DisplayComponent implements OnInit, OnDestroy {

  constructor(private alertService: AlertService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private KeepAliveService: KeepAliveService,
    private healthUnitTimeService: HealthUnitTimeService,
    private utilsClientService: UtilsClientService,
    private cdref: ChangeDetectorRef,
    private verifyWaitingTimeService: VerifyWaitingTimeService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  public panelStruct: GetPanelResponse = new GetPanelResponse();

  public isLoading: boolean = false;
  public showAverageWaitingTime: boolean = false;
  public onlineOffline: boolean = navigator.onLine;

  public lastHourWaitingTimeAverage: string | null = null;

  public idPanel: number | null = null;

  public panelTime: Date | null = null;

  private intervalId = setInterval(() => {
    if (this.onlineOffline !== navigator.onLine)
      this.onlineOffline = navigator.onLine;
  },
    1000);

  ngOnInit(): void {
    this.idPanel = parseInt(this.activatedRoute.snapshot.paramMap.get('id')!);

    this.authenticated();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  authenticated() {
    this.isLoading = true;

    let request: PanelLoginRequest = { idPanel: this.idPanel };

    this.authService.signInPanel(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          this.authService.logoutPanel();
          if (response.errorCode === 2) {
            this.openSecurityAlertModal();
          }
          return;
        }
        this.panelStruct = response;
        this.authService.updatePanelToken(response);
        this.getHealthUnitTime();
        console.log("panelStruct: ", this.panelStruct)
        if(this.panelStruct.useColor) {
          document.documentElement.style.setProperty('--primaryColorCodePanel', this.panelStruct.primaryColorCode);
          document.documentElement.style.setProperty('--secundaryColorCodePanel', this.panelStruct.secundaryColorCode);
        }
        let panel = this.panelStruct?.listPanelOrigin?.find(x => x.showAverageWaitingTime);
        if (panel != null) {
          this.showAverageWaitingTime = panel.showAverageWaitingTime;

          let request: GetQueueRequest = new GetQueueRequest();
          request.idRoom = panel.idRoom;
          request.idSector = panel.idSector;
          request.idService = panel.idService;

          this.verifyWaitingTime(request);
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.authService.logoutPanel();
      }
    });
  }

  getHealthUnitTime() {
    this.isLoading = true;
    this.healthUnitTimeService.getTime(this.panelStruct.idHealthUnit!).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        if (!this.panelTime) {
          this.utilsClientService.updateAuthenticated(true);
          this.router.navigate(['/client/display/display-options/' + this.idPanel]);
        }
        this.isLoading = false;
        this.panelTime = response.healthUnitTime;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  verifyWaitingTime(request: GetQueueRequest) {
    this.isLoading = true;
    this.verifyWaitingTimeService.getVerifyWaitingTime(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.lastHourWaitingTimeAverage = response.lastHourWaitingTimeAverage;
        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  keepAlive() {
    this.KeepAliveService.keepAlive().subscribe({
      next: (response) => {
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  openSecurityAlertModal() {
    const dialogRef = this.dialog.open(SecurityAlertModalComponent, {
      data: {
        equipment: 'painel'
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result) {
        }
      },
      error: (error) => {
      }
    });
  }
}